var React = require('react');

function Scroll (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"52DB00EF-D41C-4239-BCDD-18110C7BFEE2"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"className":"svg-color","stroke":"#565656","strokeWidth":"2"},[React.createElement("polyline",{"points":"0 10 5 15 10 10","key":0}),React.createElement("line",{"x1":"5","y1":"2","x2":"5","y2":"14.5","key":1})]))]);
}

Scroll.defaultProps = {"width":"10px","height":"17px","viewBox":"0 0 10 15","version":"1.1"};

module.exports = Scroll;

Scroll.default = Scroll;
